import React, { useState, useEffect } from "react";
import { Fab, Zoom, useTheme } from "@mui/material";
import { KeyboardArrowUp } from "@mui/icons-material";

const ScrollToTopButton = ({
  showThreshold = 300,
  scrollDuration = 800,
  bottom = 120,
  right = 34,
}) => {
  const [showButton, setShowButton] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);
  const theme = useTheme();

  // Mostrar/ocultar botón basado en posición de scroll
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      setShowButton(scrollTop > showThreshold);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // Verificar posición inicial
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showThreshold]);

  // Función para scroll suave al top
  const scrollToTop = () => {
    if (isScrolling) return;

    setIsScrolling(true);

    const startPosition = window.scrollY;
    const startTime = performance.now();

    const animateScroll = (currentTime) => {
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / scrollDuration, 1);

      // Función de easing para suavizar la animación
      const easeInOutCubic = (t) => {
        return t < 0.5
          ? 4 * t * t * t
          : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
      };

      const ease = easeInOutCubic(progress);
      const currentPosition = startPosition * (1 - ease);

      window.scrollTo(0, currentPosition);

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      } else {
        setIsScrolling(false);
      }
    };

    requestAnimationFrame(animateScroll);
  };

  return (
    <Zoom in={showButton} timeout={300}>
      <Fab
        color="primary"
        size="medium"
        onClick={scrollToTop}
        disabled={isScrolling}
        sx={{
          position: "fixed",
          bottom: bottom,
          right: right,
          zIndex: theme.zIndex.fab,
          boxShadow: theme.shadows[8],
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            transform: "scale(1.1)",
            boxShadow: theme.shadows[12],
          },
          "&:active": {
            transform: "scale(0.95)",
          },
          "&.Mui-disabled": {
            opacity: 0.7,
          },
        }}
        aria-label="Volver arriba"
        title="Volver arriba"
      >
        <KeyboardArrowUp
          sx={{
            fontSize: 28,
            transition: "transform 0.2s ease-in-out",
            transform: isScrolling ? "rotate(180deg)" : "rotate(0deg)",
          }}
        />
      </Fab>
    </Zoom>
  );
};

export default ScrollToTopButton;
